<template>
  <div>
    <v-alert
      text
      color="info"
      type="info"
      prominent
      class="text-center"
    >
      <h3 class="headline mr-10 pr-5" v-text="tokenBalanceMessage" />
    </v-alert>

    <tokens-history-list
      :value="historyList"
      :company-id="companyId"
      :loading="loadingData"
      :search="search"
    />

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Repositories from 'src/repositories'

import TokensHistoryList from '../components/TokensHistoryList'

export default {
  name: 'TokensHistoryContainer',
  components: {
    TokensHistoryList,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    historyList: [],
    loadingData: false,
  }),
  computed: {
    ...mapGetters('me', {
      companyTokenBalance: 'companyTokenBalance',
      companyId: 'companyId',
    }),
    tokenBalanceMessage () {
      const balance = this.companyTokenBalance
      return this.$tc('tokens.balance', balance, { balance })
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'TokensHistory') {
          this.fetchData()
          this.refreshCompany()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    ...mapActions('me', {
      refreshCompany: 'refreshCompany',
    }),
    async fetchData () {
      this.loadingData = true
      this.historyList = await Repositories.myCompany.getTokensHistory()
      this.loadingData = false
    },
  },
}
</script>
